const VueTruncate = require("vue-truncate-filter");
const moment = require("moment");
Vue.use(VueTruncate);

Vue.filter("capitalize", function(value) {
	if (!value) return "";
	value = value.toString();
	return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter("money", function(value) {
	const formatter = new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: "GBP",
		minimumFractionDigits: 2
	});
	return formatter.format(value);
});

Vue.filter("first_char", function(value) {
	if (!value) return "";
	return value.split("")[0];
});
Vue.filter("date", function(value) {
	if (!value) return "";
	return moment(value).format("LL");
});
Vue.filter("date_time", function(value) {
	if (!value) return "";
	return moment(value).format("LLL");
});
Vue.filter("date_time_short", function(value) {
	if (!value) return "";
	return moment(value).format("DD/MM/YYYY HH:mm");
});
Vue.filter("time_ago", function(value) {
	if (!value) return "";
	return moment(value).fromNow();
});
Vue.filter("ellipsis", function(value, length = 5, useWordBoundary = false) {
	if (value.length <= length) {
		return value;
	}
	var subString = value.substr(0, length - 1);
	return (useWordBoundary ? subString.substr(0, subString.lastIndexOf(" ")) : subString) + "...";
});

Vue.filter("money_format", value => {
	return value.toFixed(2);
});

Vue.prototype.trans = function(key) {
	return _.get(window.trans, key, key);
};



// WEBPACK FOOTER //
// ./src/filters.js